import { Image } from '@provider-portal/promotions-common/types';

export const IMAGES: Record<string, Image> = {
  deliveryDiscountRecommendation: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/delivery-discount-recomendation-1.png',
    width: 192 / 2,
  },
  salesRecommendation: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/sales-recomendation-1.png',
    width: 248 / 2,
  },
  wholeMenuDiscountRecommendation: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/whole-menu-discount-recomendation-1.png',
    width: 204 / 2,
  },
  ratingIncreaseRecommendation: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/rating-increase-recomendation-1.png',
    width: 272 / 2,
  },
  emptyActivePromotions: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/empty-active-promotions-2x.png',
    width: 232 / 2,
  },
  bestUsersRecommendation: {
    url: 'https://images.bolt.eu/delivery_provider/provider_portal_promotions/best-users-recommendations-2x.png',
    width: 232 / 2,
  },
};
